export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-background-50"></div>

      <div className="absolute top-20 right-0 w-[500px] h-[500px] md:w-[700px] md:h-[700px] rounded-full bg-primary-500/5 blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-[300px] h-[300px] md:w-[500px] md:h-[500px] rounded-full bg-accent-500/5 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 w-full max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs md:text-sm text-primary-400 whitespace-nowrap">
                永久免费 · 蓝光画质 · 秒开播放
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 leading-tight mb-4">
              桃子影院
              <span className="block text-primary-400 mt-1">
                高清电影电视剧超清在线观看平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              桃子影院汇集海量高清电影、热门电视剧与经典影视资源，覆盖动作、喜剧、悬疑、爱情、科幻等多种类型。
              每日持续更新最新院线大片与热播剧集，依托高速CDN节点实现蓝光画质秒开播放，告别缓冲等待。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              无论您是追剧党还是电影迷，桃子影院都为您的闲暇时光提供最流畅、最高清的观影体验。全站资源永久免费，随时随地畅享影视盛宴。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                  10万+
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">高清影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  每日更新
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">热播剧集同步</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-400">
                  4K蓝光
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">多线路秒开</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-400 text-background-950 font-medium rounded-lg transition-all duration-200 text-center whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="w-full sm:w-auto px-8 py-3 bg-background-200 hover:bg-background-300 text-foreground-200 border border-background-300 rounded-lg transition-all duration-200 text-center whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-2xl overflow-hidden bg-background-200/50 border border-background-300/30 p-2 md:p-3">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20warm%20golden%20and%20peach%20toned%20light%20streaks%20over%20a%20dark%20theater%20atmosphere%2C%20film%20reel%20silhouettes%2C%20soft%20dramatic%20lighting%2C%20elegant%20minimal%20design%2C%20luxurious%20cinema%20vibe%2C%20no%20text%20no%20faces%2C%20atmospheric%20and%20rich%20texture&width=1040&height=720&seq=hero-cinema-visual&orientation=landscape"
                alt="桃子影院 - 高清影视在线观看平台主视觉"
                className="w-full h-auto rounded-xl object-cover aspect-[4/3]"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.classList.add('min-h-[300px]');
                    parent.classList.add('flex');
                    parent.classList.add('items-center');
                    parent.classList.add('justify-center');
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}